import type { RuleObject } from 'antd/lib/form'
import { isValidNhsNumber } from 'common/validation/functions'
import { cleanNHSFormattedNumber } from './utils'

export const gbPhoneValidator = async (
  _rule: RuleObject,
  value: string
): Promise<void> => {
  const pattern = /^(?:0|\+?44)(?:\d\s?){9,10}$/
  if (pattern.test(value)) {
    return Promise.resolve()
  }

  return Promise.reject(new Error('Please enter a valid GB phone number!'))
}

export const nhsNumberValidator = async (
  _rule: RuleObject,
  value: string
): Promise<void> => {
  if (!value) {
    return Promise.resolve()
  }
  const cleanFormattedValue = cleanNHSFormattedNumber(value)
  const { isValid, message } = isValidNhsNumber(cleanFormattedValue)
  if (isValid) {
    return Promise.resolve()
  }

  return Promise.reject(new Error(message))
}

export const healthCareNumberValidator = async (
  _rule: RuleObject,
  value: string
): Promise<void> => {
  if (cleanNHSFormattedNumber(value)?.length === 12) {
    return Promise.resolve()
  }

  return Promise.reject(new Error('Health Care Number must be 12 digits long'))
}
